import React, { CSSProperties, useCallback } from "react";
import classNames from "classnames";
import {   
   DropdownMenu,
   DropdownToggle,
   UncontrolledDropdown,
} from "Components/ReactstrapSlim";
import { Building } from "Components/Icons";
import { getScrollbarWidth } from "Utils/getScrollbarWidth";
import { CATEGORIES, MODIFIERS } from "./constants";
import CategoryList from "./CategoryList";
import SolutionCard from "./SolutionCard";

import dropdownClasses from "./ClearDropdown.module.scss";
import classes from "./SolutionsDropdown.module.scss";

const menuStyle = {
   "--scrollbar-width": getScrollbarWidth() + "px",
} as CSSProperties;

const SolutionsDropdown: React.FC = () => {

   const action = useCallback(() => {
      window.open("/share-office-meeting-space");
   }, []);

   return (
      <UncontrolledDropdown>
         <DropdownToggle caret color="transparent" className="header-btn-link">
            Solutions
         </DropdownToggle>
         <DropdownMenu
            modifiers={MODIFIERS}
            className={classes.dropdownMenu}
            style={menuStyle}
            cssModule={dropdownClasses}
         >
            <div className={classes.dropdownMenuContainer}>
               <div
                  className={classNames(
                     classes.dropdownMenuContent,
                     classes.dropdownContentContainer,

                  )}
               >
                  {CATEGORIES.map((category, i) => (
                     <div key={i} className={classes.dropdownMenuItems}>
                        {category.map(({ title, items }) => (
                           <CategoryList
                              key={title}
                              title={title}
                              items={items}
                           />
                        ))}
                     </div>
                  ))}
                  <SolutionCard
                     className={classes.card}
                     icon={<Building />}
                     title="Become a host."
                     description="Join the largest global flexible office marketplace."
                     actionText="List workspace"
                     action={action}
                  />
               </div>
            </div>           
         </DropdownMenu>
      </UncontrolledDropdown>
   );
};

export default SolutionsDropdown;
